export const getQueryParams = (search) => {
    const params = {}
    const queryParam = new URLSearchParams(search);
    for (const [key, value] of queryParam.entries()) {
        params[key] = value;
    }
    return params;
}

export const isNativeWebView = () => {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isNativeUser = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const OS = queryParams.get("OS");
    if (OS) {
        sessionStorage.setItem("userOS", OS);
        return OS === "iOS" || OS === "Android";
    }
    const storedOS = sessionStorage.getItem("userOS");
    return storedOS === "iOS" || storedOS === "Android";
};